<template>
  <section class="section-netcore-blog">
    <h2>You can also explore</h2>
    <p>Netcore connects &amp; unifies your data across all sources, connects to your marketing channels and provides you with control over AI Powered automation and personalization.</p>
    <div class="products-tiles animate__animated move-in-up animate__fadeInUp slow" id="AllProductsTiles">
      <a class="hero-tile" href="https://netcorecloud.com/customer-engagement/" data-factors-click-bind="true">
        <div class="product-icon">
          <img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/product_tiles/customer-engagement.svg" alt=" " width="50" height="50">
        </div>
        <div class="v-spacer-10"></div>
        <div class="hero-tile-header">Customer<br>Engagement</div>
        <div class="hero-tile-hidden" style="display: none;">
          <div class="hero-tile-header-hidden">
            Customer<br>Engagement
          </div>
          <div class="hero-tile-text-hidden">
            Deliver digital experiences that delight each customer
          </div>
          <div class="hidden-arrow">
            <img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/arrow_right.svg" alt=" ">
          </div>
        </div>
      </a>
      <a class="hero-tile" href="https://netcorecloud.com/product-experience/" data-factors-click-bind="true">
        <div class="product-icon">
          <img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/product_tiles/customer-engagement.svg" alt=" " width="50" height="50">
        </div>
        <div class="v-spacer-10"></div>
        <div class="hero-tile-header">Product <br /> Experience</div>
        <div class="hero-tile-hidden" style="display: none;">
          <div class="hero-tile-header-hidden">
            Product <br /> Experience
          </div>
          <div class="hero-tile-text-hidden">
            Be a part of a community of clean email senders.
          </div>
          <div class="hidden-arrow">
            <img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/arrow_right.svg" alt=" ">
          </div>
        </div>
      </a>
      <!-- <a class="hero-tile" href="/customer-engagement/" data-factors-click-bind="true">
        <div class="product-icon">
          <img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/product_tiles/customer-engagement.svg" alt=" " width="50" height="50">
        </div>
        <div class="v-spacer-10"></div>
        <div class="hero-tile-header">Martech<br>Brain</div>
        <div class="hero-tile-hidden" style="display: none;">
          <div class="hero-tile-header-hidden">
            Martech<br>Brain
          </div>
          <div class="hero-tile-text-hidden">
            Realize your martech stratergies using Netcore tools.
          </div>
          <div class="hidden-arrow">
            <img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/arrow_right.svg" alt=" ">
          </div>
        </div>
      </a> -->
      <a class="hero-tile" href="https://netcorecloud.com/amp/" data-factors-click-bind="true">
        <div class="product-icon">
          <img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/product_tiles/customer-engagement.svg" alt=" " width="50" height="50">
        </div>
        <div class="v-spacer-10"></div>
        <div class="hero-tile-header">AMP Email</div>
        <div class="hero-tile-hidden" style="display: none;">
          <div class="hero-tile-header-hidden">
            AMP Email
          </div>
          <div class="hero-tile-text-hidden">
            Now make your emails more engaging with AMP
          </div>
          <div class="hidden-arrow">
            <img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/arrow_right.svg" alt=" ">
          </div>
        </div>
      </a>
    </div>
    <div class="products-tiles animate__animated move-in-up animate__fadeInUp slow product-mobile-view" id="AllProductsTiles">
      <a class="hero-tile" href="/blog/" data-factors-click-bind="true">
        <div class="product-icon">
          <img src="@/assets/img/tutorial/journey_orchestration.svg" alt=" " width="50" height="50">
        </div>
        <div class="v-spacer-10"></div>
        <div class="hero-tile-header">Netcore Blog</div>
      </a>
      <a class="hero-tile hero-title-top" href="/customer-engagement/" data-factors-click-bind="true">
        <div class="product-icon">
          <img src="@/assets/img/tutorial/dynamic_web_personalization.svg" alt=" " width="50" height="50">
        </div>
        <div class="v-spacer-10"></div>
        <div class="hero-tile-header">Customer Engagement</div>
      </a>
    </div>
    <div class="products-tiles animate__animated move-in-up animate__fadeInUp slow product-mobile-view" id="AllProductsTiles">
      <a class="hero-tile" href="/raman-ai-engine/" data-factors-click-bind="true">
        <div class="product-icon">
          <img src="@/assets/img/tutorial/raman_insights.svg" alt=" " width="50" height="50">
        </div>
        <div class="v-spacer-10"></div>
        <div class="hero-tile-header">Martech Brain</div>
      </a>
      <a class="hero-tile hero-title-top" href="/amp/" data-factors-click-bind="true">
        <div class="product-icon">
          <img src="@/assets/img/tutorial/app_churn_management.svg" alt=" " width="50" height="50">
        </div>
        <div class="v-spacer-10"></div>
        <div class="hero-tile-header">AMP</div>
      </a>
    </div>
  </section>
</template>
<script>
export default {
  name: "NetcoreBlogSection"
}
</script>
<style scoped>
  .section-netcore-blog {
    margin-bottom: 50px;
  }
</style>